export default {
  name: 'Map - 2',
  tab: 'map',
  type: 'map-fullwidth-section',
  content: {
    'map-latitude': '59.9139',
    'map-longitude': '10.7522',
    'map-zoom': '10'
  },
  design: {},
  layout: {
    'map-height': '450px'
  },
  advanced: {}
}
